module.exports = __webpack_public_path__ + "static/media/Financial_Year.675d5d4c.svg";